export class SoandSoitemRequest{
    saleOrderId:number;
    saleOrderItemId:number;
    constructor(
        saleOrderId:number,
        saleOrderItemId:number
    ){
        this.saleOrderId=saleOrderId;
        this.saleOrderItemId=saleOrderItemId;
    }
}
export class LotAndOperationReq{
    lotNumber:string;
    operation:string;
    count?:number;
    plantId?:number
    year?:number
    product?:string
    constructor(lotNumber:string,operation:string,count?:number,plantId?:number,year?:number,product?:string){
        this.lotNumber=lotNumber;
        this.operation=operation;
        this.count = count
        this.plantId = plantId
        this.year = year
        this.product = product
    }
    
}
export class TransportChargesReq{
    contractorId?:number;
 villageId?:number;
 fromDate?: string | Date;
 toDate?: string | Date;

    village?:string
 
    constructor(contractorId?:number,villageId?:number,fromDate?: string | Date, toDate?: string | Date,village?:string){
        this.contractorId = contractorId
        this.villageId = villageId
        this.fromDate = fromDate
        this.toDate = toDate
        this.village = village
    }

}